import React, { useEffect, useRef, useState } from "react";
import { useAuthContext } from "../../Hooks/useAuthContext";

export default function MediaUploadField({ kind, onUploaded, onBusyChange }) {
  const { user } = useAuthContext();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [uploadedName, setUploadedName] = useState("");
  const request = useRef(null);
  const audio = kind === "audio";
  const maxMB = audio ? 250 : 20;

  useEffect(() => () => {
    request.current?.abort();
    onBusyChange(kind, false);
  }, [kind, onBusyChange]);

  const upload = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;
    setError("");
    if (!file.size || file.size > maxMB * 1024 * 1024) {
      setError(`Choose a non-empty file up to ${maxMB} MB.`);
      return;
    }
    const controller = new AbortController();
    request.current = controller;
    setBusy(true);
    onBusyChange(kind, true);
    try {
      const form = new FormData();
      form.append("file", file);
      const response = await fetch(audio ? "/api/posts/upload-audio" : "/api/posts/upload-thumbnail", {
        method: "POST", body: form, signal: controller.signal,
        headers: user?.token ? { Authorization: `Bearer ${user.token}` } : {},
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok || !result.url) throw new Error(result.message || result.error || "Upload failed. Please try again.");
      onUploaded(result.url);
      setUploadedName(file.name);
    } catch (uploadError) {
      if (!controller.signal.aborted) setError(uploadError.message);
    } finally {
      if (!controller.signal.aborted) { setBusy(false); onBusyChange(kind, false); }
    }
  };

  return (
    <div className="media-upload-field">
      <label>
        <span>{audio ? "Upload audio" : "Upload cover image"} <small>(up to {maxMB} MB)</small></span>
        <input type="file" accept={audio ? "audio/*,.mp3,.wav,.m4a,.aac,.ogg,.opus,.flac,.webm,.mp4,.aiff,.aif,.caf" : "image/jpeg,image/png,image/webp,image/gif,image/avif,image/heic,image/heif"} disabled={busy} onChange={upload} />
      </label>
      {busy && <p role="status">Uploading… Please wait before sharing.</p>}
      {!busy && uploadedName && <p role="status">Uploaded: {uploadedName}</p>}
      {error && <p role="alert">{error}</p>}
    </div>
  );
}
